import React from 'react';
import { UserReward } from '../../Types/UserReward';
import RewardCard, { RewardCardRarity } from '../RewardCard';

interface CoinsRewardProps {
  reward: UserReward;
}

const CoinsReward: React.FC<CoinsRewardProps> = ({ reward }) => {
  const value = reward.rewardData.amount as number;

  const coinContent = (
    <div className="flex flex-col items-center justify-center">
      <div className="w-16 h-16 flex items-center justify-center mb-1">
        <img
          src={require('../../assets/icons/coins.png')}
          alt=""
          className="w-12 h-12 object-contain"
        />
      </div>
      <div className="text-yellow-600 font-bold text-sm mb-1">+{value}</div>
    </div>
  );

  return (
    <RewardCard
      reward={reward}
      title="Coins"
      description="Swap your coins for Robux"
      rarity={RewardCardRarity.Common}
      content={coinContent}
      type="Currency"
    />
  );
};

export default CoinsReward;
